import {getData, postData} from './redux_data';
import {
    GET_MODELOS_MAQUINA,
    MODIFY_MODELO_MAQUINA,
    ADD_MODELO_MAQUINA,
    DELETE_MODELO_MAQUINA,
    UPDATE_MODELOS_MAQUINA,
} from '../constants/action_types';

export function getModelosMaquina() {
    return getData('vmodelomaquinas', GET_MODELOS_MAQUINA);
}

export function modifyModeloMaquina(modeloMaquina) {
    return (dispatch, getState) => {
        dispatch({ type: MODIFY_MODELO_MAQUINA, payload: modeloMaquina });
    }
}

export function addModeloMaquina(modeloMaquina) {
    return (dispatch, getState) => {
        dispatch({ type: ADD_MODELO_MAQUINA, payload: modeloMaquina });
    }
}

export function removeModeloMaquina(modeloMaquina) {
    return (dispatch, getState) => {
        dispatch({ type: DELETE_MODELO_MAQUINA, payload: modeloMaquina });
    }
}

export function updateModelosMaquinaDB (modeloMaquina) {
    // return (dispatch, getState) => {
    //     dispatch({ type: UPDATE_MODELOS_MAQUINA, payload: modeloMaquina })
    //     let token = getState().oidc.user ? getState().oidc.user.access_token : "";
    //     axios.post(config.API_URI() + 'vmodelomaquinas/modelos', modeloMaquina,
    //         {
    //             headers: {
    //                 Authorization: "Bearer " + token
    //             }
    //         }
    //     ).then((response) => {
    //         dispatch({ type: UPDATE_MODELOS_MAQUINA + "_SUCCESS", payload: response })
    //         dispatch({
    //             type: OPEN_DIALOG,
    //             modalType: 'SimpleMessage',
    //             modalProps: { message: 'Cambios guardados!' },
    //             dialogid: 'success_update_modelos_maquina'
    //             });
    //     }).catch((error) => {
    //         dispatch({
    //             type: OPEN_DIALOG,
    //             modalType: 'SimpleMessage',
    //             modalProps: { message: error.response.data.message, exception: error.response.data.ex },
    //             dialogid: 'error_update_modelos_maquina'
    //         });
    //     });
    // }

    return postData('vmodelomaquinas/modelos', UPDATE_MODELOS_MAQUINA, modeloMaquina, 'Modelos de máquina actualizados', undefined);
}

